// Bank, kjørebok og Altinn (en).
window.PlummeI18n.register('en', {
  'bank.analysis.running': 'Analysing …',
  'bank.analysis.completed': 'Analysed by SuperPlumma',
  'bank.analysis.start': 'Start analysis',
  'bank.analysis.retry': 'Retry analysis',
  'bank.periodImport.dropFile': 'Drop the bank file here',
  'bank.periodImport.missingMonth': 'Missing bank statement for {{period}}',
  'bank.periodImport.monthUploadHelp': 'Upload CSV, PDF or XLSX for {{account}}. The file can cover one or several months, regardless of the selected month. Bank transactions are assigned to the correct month by date. You can also supplement an earlier import with a new statement.',
  'bank.periodImport.title': 'Upload bank file',
  'bank.periodImport.help': 'Upload transactions or statements for one or more months. Uploads are independent of the selected month.',
  'bank.periodImport.chooseAccount': 'Choose bank account',
  'bank.periodImport.coverageHelp': 'Check the export period. The first and last transaction dates are only suggestions; days without transactions may also be included.',
  'bank.periodImport.from': 'Export from (inclusive)',
  'bank.periodImport.to': 'Export through (inclusive)',
  'bank.periodImport.confirmCoverage': 'The file contains all bank movements in this period, without search or amount filters.',
  'bank.periodImport.closing': 'Closing bank balance',
  'bank.periodImport.balanceHelp': 'Balances are optional for import. Use the booked bank balance immediately before the start date and at the end of the final date. Leave unknown balances blank. A later statement can supply opening and closing balances.',
  'bank.periodImport.preview': 'Review import',
  'bank.periodImport.save': 'Import bank file',
  'bank.periodImport.continue': 'Continue where I was',
  'bank.periodImport.process': 'Process entire period',
  'bank.periodImport.result': '{{added}} new transactions · {{matched}} recognized',
  'bank.periodImport.preserved': 'Previous work, postings and document links have been preserved.',
  'bank.periodImport.fileMissing': 'Transactions were saved, but the original file could not be stored. Upload it again to preserve the documentation.',
  'bank.periodImport.monthLines': '{{count}} lines',
  'bank.periodImport.balanceFound': 'Closing balance recorded',
  'bank.periodImport.balanceMissing': 'Bank balance missing',
  'bank.periodImport.chooseMatch': 'Choose existing transaction with different text',
  'bank.periodImport.newTransaction': 'This is a separate, new transaction',
  'bank.periodImport.worklist': 'Bank · combined worklist',
  'bank.periodImport.worklistHelp': 'Process lines across months. Each month keeps its own balance checks and reconciliation.',
  'bank.periodImport.needBalances': 'Bank balance missing. You can process lines now and add a statement or documented opening/closing balance before reconciliation.',
  'bank.periodImport.partial': 'This is a partial month. Process lines now and add the remainder before completing the month.',
  'bank.periodImport.files': 'Imported original files',
  'bank.periodImport.openPeriods': 'Open imported periods',
  'bank.control.ledgerDifference': '{{month}}: Ledger closing balance {{booked}}, bank closing balance {{bank}}. Difference {{difference}}. Review the month again.',
  'bank.control.openingLedgerDifference': '{{month}}: Bank opening balance {{bank}}, ledger opening balance {{booked}}. Difference {{difference}}. Enter a balanced opening balance under Accounting before completing the reconciliation.',
  'bank.control.ledgerMismatchTitle': 'Difference against the ledger',
  'bank.archiveLedgerMismatch': 'Cannot archive: the ledger balance on {{date}} is {{booked}}, while the bank balance is {{bank}}. Difference {{difference}}.',
  'bank.statementDiscrepancy': 'Statement difference',
  'bank.balanceDiscrepancy': 'Balance difference',
  'bank.balanceDiscrepancyHelp': 'The difference between the ledger balance and the bank closing balance.',
  'bank.removedLineCannotBook': 'A misread bank line removed from the reconciliation cannot be posted.',
  'bank.control.missingBalance': '{{month}}: The bank statement is missing its closing balance. Ledger closing balance is {{booked}}. The balances have not been compared.',
  'bank.control.ready': 'Statements cover the period and have been reconciled.',
  'bank.control.openingSetupMissing': '{{account}} is missing a confirmed opening date or bank balance. Go to Settings → Bank and confirm the bank balance against the opening figures. Do not enter the opening figures again. Enter 0 only if the statement shows zero.',
  'bank.control.needsReview': 'Bank review found incomplete opening details, missing statements, unreconciled periods, balance differences or postings before the opening balance.',
  'bank.control.missing': 'Missing bank statements for {{year}}: {{months}}.',
  'bank.control.unsettled': 'Statements are uploaded but not fully reconciled for {{year}}: {{months}}.',
  'bank.control.existingBeforeStart': '{{count}} posting(s) predate the opening balance on {{date}}. Review the postings and opening balance in bank settings. Earlier postings do not automatically change the opening balance.',
  'bank.control.postingBeforeStart': 'The posting predates the opening balance for bank account {{account}} ({{date}}). Review the date and opening balance in bank settings before posting.',

  'bank.patternBased': 'Based on a previous pattern',
  'bank.patternTitle': 'Previous pattern',
  'bank.patternExplanation': 'Plumme suggests this treatment because similar bank lines were previously posted the same way. The suggestion still requires approval. You can stop the pattern without changing previous entries.',
  'bank.patternVariableAmounts': 'Plumme remembers the type and account, but does not reuse previous principal, interest, or fee amounts. Check the amounts against the documentation each time.',
  'bank.patternStop': 'Stop using this pattern',
  'bank.patternStopped': 'The pattern has been stopped',
  'bank.patternStopFailed': 'Could not stop the pattern.',
  'bank.backToYearClosing': 'Back to year-end closing',
  // ------------------------------ Bank, mileage log, Altinn (misc.jsx)
  'bank.editEntry': 'Edit entry',
  'bank.bankLine': 'Bank line',
  'bank.saveAndPost': 'Save and post',
  'bank.readFrom': 'Information read from',
  'bank.voucherType': 'Voucher type',
  'bank.purchaseVoucher': 'Purchase voucher',
  'bank.salesVoucher': 'Sales voucher',
  'bank.counterparty': 'Counterparty',
  'bank.supplierOrParty': 'Supplier / counterparty',
  'bank.businessAccount': 'Business account',
  'bank.paidPrivately': 'Paid privately',
  'bank.uploadOrForward': 'Upload or forward vouchers by email — we read what we can.',
  'bank.uploadedReceived': 'Uploaded/received',
  'bank.searchVouchers': 'Search vouchers — file name, PDF, image…',
  'bank.noInboxVouchers': 'No vouchers in the Inbox yet',
  'bank.noInboxVouchersHelp': 'Upload a voucher or forward supplier invoices to the voucher address.',
  'bank.allMonths': 'All months',
  'bank.uploading': 'Uploading …',
  'bank.uploadingCount': 'Uploading {{done}}/{{total}} …',
  'bank.analyzingCount': 'Analyzing {{done}}/{{total}} …',
  'bank.dragToReorder': 'Drag to reorder',
  'bank.editTheEntry': 'Edit the entry',
  'bank.moveToTrash': 'Move to the bin',
  'bank.dropFilesHere': 'Drop the files here',
  'bank.weReadWhatWeCan': 'We read what we can',
  'bank.deleteForeverTitle': 'Delete permanently?',
  'bank.deleteForever': 'Yes, delete permanently',
  'km.time': 'Time',
  'km.avgSpeed': 'Average speed',
  'km.useDistance': 'Use distance',
  'km.searching': 'Searching...',
  'km.from': 'From',
  'km.to': 'To',
  'km.resolvingAddress': 'Resolving address...',
  'km.gpsGapTitle': 'Gap in the GPS track',
  'km.gpsGap': 'Tracking lost your position along the way, and {km} km is not included. Check the distance before you save the trip.',
  'km.sub': 'Register trips and keep track of the mileage allowance.',
  'km.newTripOrLog': 'New trip / Mileage log',
  'km.newTripOrLogHelp': '"New trip" registers a new trip. "Mileage log" shows the overview of every trip you have recorded, with total distance and deduction.',
  'km.tripDetails': 'Trip details',
  'km.tripDetailsHelp': 'Fill in the details that document the trip: date, purpose (why you drove), from and to, and the number of kilometres. The purpose matters — the trip must be work related to give a deduction.',
  'km.purposePh': 'E.g. customer meeting at Lunde & Vik',
  'km.purposeQuickPicks': 'Quick picks',
  'km.returnTrip': 'Return trip',
  'km.returnTripHelp': 'Tick this when you drove the same way back. The kilometres and the deduction are doubled, and the trip is documented as a return trip in the mileage log.',
  'km.returnTripRow': 'Return trip',
  'km.perLeg': 'One way',
  'km.removeStop': 'Remove stop',
  'km.addStop': 'Add stop',
  'km.addStopHelp': 'Add a stop between the start and the destination — useful when the trip passes several places. Each stop becomes part of the documented route.',
  'km.calcAuto': 'Calculate km automatically',
  'km.calcAutoHelp': 'Works out the number of kilometres between the start, stops and destination automatically using maps, so you do not have to look up the distance yourself.',
  'km.ratePerKm': 'Rate per km',
  'km.ratePerKmHelp': 'The state rate for mileage allowance per kilometre. Plumme uses the current rate automatically to work out the deduction.',
  'km.registeredDistance': 'Registered distance',
  'km.registeredDistanceHelp': 'The number of kilometres you have entered for this trip.',
  'km.deductionAmount': 'Deduction amount',
  'km.deductionAmountHelp': 'Kilometres multiplied by the rate — the tax-free mileage allowance you can receive for the trip.',
  'km.saveHelp': 'Saves the trip in the mileage log. It counts towards the year\'s total distance and deduction, and can be documented in the event of an inspection.',
  'km.drivenThisYear': 'Driven this year',
  'km.drivenThisYearHelp': 'The total number of work kilometres you have registered so far this year.',
  'km.deductionThisYear': 'Deduction this year',
  'km.deductionThisYearHelp': 'The total mileage allowance (deduction) for this year\'s registered trips.',
  'km.searchPh': 'Search by route, purpose or date',
  'km.deleteTripTitle': 'Delete trip?',
  'km.deleteTripConfirm': 'Yes, delete',
  'bank.alreadyPostedToOperating': 'Already posted against the operating account',
  'bank.openInJournal': 'Open in the voucher journal',
  'bank.noEntriesInView': 'No entries in this view.',
  'bank.fixUp': 'Correct',
  'bank.pickLine': 'Choose line',
  'bank.noFreeLines': 'No free bank lines in this statement.',
  'bank.link': 'Link',
  'bank.statement': 'Bank statement',
  'bank.openOriginal': 'Open the original',
  'bank.downloadCsv': 'Download CSV',
  'bank.openingBalance': 'Opening balance',
  'bank.originalNotDownloadable': 'The original file cannot be downloaded.',
  'bank.viewUsesImported': 'The view below uses the bank lines that have already been imported.',
  'bank.balance': 'Balance',
  'bank.noImportedLines': 'No imported bank lines in this statement.',
  'bank.importNoTransactions': 'No transactions were found in “{{fileName}}”, but the balances show a movement of {{difference}}. Check the lines against the original before reconciling. The statement was not saved.',
  'bank.importBalanceMismatch': 'The parsed lines do not match the statement balances: a difference of {{difference}}. Check the lines against the original before reconciling. The statement was not saved.',
  'bank.importUnreadablePeriod': 'The statement period could not be read. The statement was not saved.',
  'bank.imageAnalysisUnavailable': 'Bank statement image analysis is not available yet.',
  'bank.importFailed': 'The bank statement could not be read.',
  'bank.readingStatement': 'Reading statement…',
  'bank.openStatementPreview': 'Open a preview of the bank statement',
  'bank.seeOriginal': 'View statement',
  'bank.almostDone': 'Almost there',
  'bank.linesRemaining': 'lines left to handle',
  'bank.discrepancy': 'Discrepancy',
  'bank.discrepancyHelp': 'Calculated discrepancy between the balance and the bank lines',
  'bank.openingBalanceHelp': 'The balance on the bank account at the start of the period — taken from the previous reconciliation.',
  'bank.closingBalanceHelp': 'The balance on the bank account at the end of the period, according to the bank statement. It must match the posted balance once every line has been handled.',
  'bank.useSuperPlumma': 'Use SuperPlumma',
  'bank.useSuperPlummaHelp': 'Lets SuperPlumma find suggestions for review. You approve the result before it is posted.',
  'bank.reconcileAndPost': 'Reconcile and post',
  'bank.chronologicalTitle': 'An earlier period is not reconciled',
  'bank.chronologicalBody': 'Reconcile {{period}} first. The opening balance comes from the previous statement, so a discrepancy there would go unnoticed here.',
  'bank.reconcileAndPostHelp': 'Posts the bank lines, locks the period once every line has been handled and moves the statement to the archive.',
  'bank.reconcileAndArchive': 'Reconcile and archive',
  'bank.reconcileAndArchiveHelp': 'Posts the bank lines, locks the period once every line has been handled and moves the statement to the archive.',
  'bank.existingEntryMatch.action': 'Match posted entry',
  'bank.existingEntryMatch.title': 'Match posted entry',
  'bank.existingEntryMatch.help': 'Choose the entry that already posts the same bank amount. No new posting is created.',
  'bank.existingEntryMatch.dateMismatch': 'The date differs by {days} days. Review the entry before matching it.',
  'bank.existingEntryMatch.none': 'No posted entries with the same amount and a nearby date were found.',
  'bank.existingEntryMatch.success': 'The bank line was linked to the posted entry.',
  'bank.existingEntryMatch.error': 'The bank line could not be linked.',
  'bank.reopenAndReverse': 'Reopen and reverse',
  'bank.reopenAndReverseHelp': 'Reopens the reconciled bank statement so the postings can be corrected. The period is unlocked.',
  'bank.settledTitle': 'Reconciled and posted',
  'bank.settledOn': 'Archived {{date}}',
  'bank.settledHelp': 'The statement is in the archive.',
  'bank.settledBadge': 'Reconciled',
  'bank.alreadySettled': 'This bank statement is already reconciled and archived. Reopen it if something needs correcting.',
  'bank.postedToOperating': 'Posted to the operating account',
  'bank.postedToOperatingHelp': 'These entries are posted to the operating account for this bank period.',
  'bank.linkVoucher': 'Link',
  'bank.openLinkedVoucher': 'Open {{name}}',
  'bank.openingBalanceImported': 'Read from the statement: {{amount}}',
  'bank.useExpectedOpening': 'Set opening balance to {{amount}}',
  'bank.receiptLinked': 'Linked to a bank line',
  'bank.duplicateUpload': 'Possible duplicate upload',
  'bank.ambiguousMatch': 'Several identical vouchers — pick the right one yourself',
  'bank.linkSuggestedVouchers': 'Link {{count}} suggested vouchers',
  'bank.searchLines': 'Search bank lines…',
  'bank.addLine': 'Add bank line',
  'bank.noLinesInView': 'No bank lines in this view.',
  'bank.missingVoucher': 'Missing voucher',
  'bank.missingVoucherAction': 'Missing voucher · click or drop here',
  'bank.missingVoucherHelp': 'Drag a voucher from the Inbox here to link it. If the voucher is lost or cannot be obtained, click to record it as lost.',
  'bank.markVoucherLostTitle': 'Mark voucher as lost',
  'bank.markVoucherLostHelp': 'The posting is retained, but this does not replace documentation. The follow-up is closed and the choice is stored on the bank line with a reason, timestamp and user.',
  'bank.markVoucherLostConfirm': 'Register',
  'bank.markVoucherLostSaving': 'Registering …',
  'bank.voucherLostReason': 'Explanation',
  'bank.voucherLostReasonHint': 'Required. Explain why the voucher cannot be obtained.',
  'bank.voucherLostReasonPlaceholder': 'E.g. the receipt was lost and the supplier cannot provide a copy.',
  'bank.voucherLostReasonRequired': 'Briefly explain why the voucher cannot be obtained.',
  'bank.voucherLostError': 'Could not mark the voucher as lost.',
  'bank.voucherLostUnavailable': 'Marking a voucher as lost is not connected to the backend.',
  'bank.docReason.lostText': 'The receipt is lost and cannot be obtained.',
  'bank.docReason.never': 'Never received',
  'bank.docReason.neverText': 'The supplier never sent a receipt or invoice.',
  'bank.docReason.statementOnly': 'Bank statement only',
  'bank.docReason.statementOnlyText': 'The transaction appears only on the bank statement, and no separate document exists.',
  'bank.docReason.notApplicable': 'Not applicable',
  'bank.docReason.notApplicableText': 'A separate voucher is not applicable for this posting.',
  'bank.voucherMarkedLost': 'Voucher lost',
  'bank.voucherMarkedLostToast': 'The voucher was marked as lost',
  'bank.sendVoucherBack': 'Send the voucher back to the Inbox',
  'bank.approveSuggestion': 'Approve suggestion',
  'bank.approveSuggestionHelp': 'Accepts SuperPlumma\'s suggested posting for the line and posts it accordingly.',
  'bank.review': 'Review',
  'bank.markPrivate': 'Mark as private',
  'bank.post': 'Post',
  'bank.reviewEntries': 'Review entries',
  'bank.previewUnavailable': 'Preview is not available',
  'bank.previewUnavailableHelp': 'The voucher does not have an accessible file address.',
  'bank.noVatCalculated': 'No VAT is calculated. The whole bank amount of',
  'bank.amountExVatBecomes': 'The amount excl. VAT becomes',
  'bank.actualAmountIncVat': 'The actual bank amount incl. VAT becomes',
  'bank.saveAndClose': 'Save and close',
  'bank.manualLine': 'Manual bank line',
  'bank.amountExInc': 'Bank amount excl./incl. VAT',
  'bank.amountExIncHelp': 'Tap to switch whether the amount is shown with or without VAT. Plumme converts automatically, while the actual amount from the bank transaction is still stored incl. VAT.',
  'bank.costAccount': 'Cost account',
  'bank.accountCategory': 'Account/category',
  'bank.salesAccount': 'Sales account',
  'bank.pickOpenInvoice': 'Choose an open invoice',
  'bank.noMatchingInvoices': 'No open invoices match this amount.',
  'bank.matchesVatPeriod': 'Matches the selected VAT period. Posting and marking as paid happen when the period is linked.',
  'bank.mixedUseManual': 'If the line mixes VAT, tax, corrections or other adjustments, use a manual entry.',
  'bank.matchesPayrollPeriod': 'Matches the selected withholding/employer\'s contribution period. Choose which part the bank line actually pays.',
  'bank.payrollPeriod': 'Withholding tax / employer\'s contribution period',
  'bank.whatIsPaymentFor': 'What is the payment for?',
  'bank.payrollAccountsHelp': 'Withholding tax is 2600, employer\'s contribution is 2770.',
  'bank.feeHelp': 'Use this for bank and card fees. The amount is posted without VAT against',
  'bank.noFeeAccount': 'No suitable fee account exists in the chart of accounts.',
  'bank.roundingHelp': 'Only use this for a genuine small rounding difference. The amount is posted without VAT against',
  'bank.swapFromTo': 'Swap from and to',
  'bank.pickTwoAccounts': 'Choose two different accounts before saving the manual entry.',
  'bank.manualPostingBankMismatch': 'The total posted to the bank account must equal the bank line.',
  'bank.supplierVatHelp': 'The VAT rate on the supplier invoice. Input VAT is calculated from the amount.',
  'bank.supplierDueDateHelp': 'The due date on the supplier invoice. If the bank line covers only part of the amount, the rest is still an open item, and the due date is what the ageing is measured from.',
  'bank.supplierInvoiceGross': 'Total invoice amount',
  'set.bank.currency': 'Currency',
  'set.bank.accountNumberHelp': 'The account number as the bank states it. Dots and spaces are removed automatically — the ledger, import files and payments compare the digits, and a number with separators does not match its own bank statement.',
  'set.bank.currencyName.NOK': 'Norwegian kroner',
  'set.bank.currencyName.SEK': 'Swedish kronor',
  'set.bank.currencyName.DKK': 'Danish kroner',
  'set.bank.currencyName.EUR': 'Euro',
  'set.bank.currencyName.USD': 'US dollars',
  'set.bank.currencyName.GBP': 'British pounds',
  'set.bank.currencyName.CHF': 'Swiss francs',
  'set.bank.currencyName.ISK': 'Icelandic kronur',
  'set.bank.currencyName.PLN': 'Polish zloty',
  'set.bank.currencyName.CZK': 'Czech koruna',
  'set.bank.currencyName.JPY': 'Japanese yen',
  'set.bank.currencyName.CAD': 'Canadian dollars',
  'set.bank.currencyName.AUD': 'Australian dollars',
  'set.loans.title': 'Loan register',
  'set.loans.sub': 'Loans and long-term debt with a repayment plan',
  'set.loans.help': 'Without this, a loan is only a ledger account. The balance says what is left, not how much falls due within the next year — and without that, current and non-current debt cannot be separated. Instalments are still booked as before, through the bank or a voucher.',
  'set.loans.none': 'No loans registered.',
  'set.loans.add': 'Add loan',
  'set.loans.remove': 'Delete loan',
  'set.loans.lender': 'Lender',
  'set.loans.ledgerAccount': 'Ledger account',
  'set.loans.ledgerAccountHelp': 'The account the loan sits on. Without it the loan cannot be reconciled against the books.',
  'set.loans.missingAccount': 'No account',
  'set.loans.originalAmount': 'Original loan amount',
  'set.loans.interestRate': 'Interest rate (%)',
  'set.loans.startDate': 'Start date',
  'set.loans.repaymentType': 'Repayment type',
  'set.loans.termsPerYear': 'Terms per year',
  'set.loans.monthly': 'Monthly (12)',
  'set.loans.quarterly': 'Quarterly (4)',
  'set.loans.halfYearly': 'Half-yearly (2)',
  'set.loans.yearly': 'Yearly (1)',
  'set.loans.installmentAmount': 'Instalment amount',
  'set.loans.installmentHelp': 'The instalment per term for a serial loan, the full term payment for an annuity loan.',
  'set.loans.remainingTerms': 'Remaining terms',
  'set.loans.interestOnlyUntil': 'Interest-only until',
  'set.loans.interestOnlyHelp': 'Leave empty if the loan has no interest-only period.',
  'set.loans.security': 'Security and pledges',
  'set.loans.planIncomplete': 'The plan is not complete enough to calculate what falls due within the next year. The reconciliation says so rather than guessing.',
  'set.loans.planSays': 'The plan says {amount} falls due within the next twelve months. Classifying it as current or non-current is still a professional judgement.',
  'set.bank.currencyHelp': 'The account currency. NOK for ordinary Norwegian accounts. An account in another currency is reconciled by translation at the balance sheet date rate, not by direct comparison.',
  'bank.supplierInvoiceGrossHelp': 'Fill this in only if the bank line covers part of the invoice. The invoice is then registered at its full amount, the bank line is booked as a part payment, and the rest stays outstanding on the supplier.',
  'bank.shortDescriptionPh': 'Short description of the transaction…',
  'bank.previewVoucher': 'Preview the voucher',
  'bank.noVoucherUploaded': 'No voucher uploaded',
  'bank.fetchFromInbox': 'Get from the Inbox',
  'bank.backToBank': 'Back to Bank',
  'bank.privateBank': 'Private bank',
  'bank.privateBankHelp': 'The private account is used as a tidying tool: go through the lines, mark the ones that are really business expenses as "Operating" (they are then posted to the operating account), and ignore the purely private ones. That way you capture business costs you have paid for privately.',
  'bank.finishReview': 'Finish the review',
  'bank.finishReviewHelp': 'Posts the lines you have marked as operating to the operating account, and archives the reviewed private statement.',
  'bank.dragVoucherFromInbox': 'Drag a voucher from the Inbox',
  'bank.toOperations': 'To operations',
  'bank.toOperationsHelp': 'Opens the posting options for the line, so the account, VAT, voucher and type are correct before it is moved to operations.',
  'bank.ignore': 'Ignore',
  'bank.ignoreHelp': 'Marks the line as purely private and keeps it out of the business accounts. Tap again to undo.',
  'bank.voucherReceivedOn': 'Voucher received on',
  'bank.superPlummaFetches': 'SuperPlumma fetches and links',
  'bank.searchInbox': 'Search the Inbox...',
  'bank.reopen': 'Open again',
  'bank.viewPostings': 'View postings',
  'bank.waitingPrevious': 'Waiting for previous',
  'bank.waitingPreviousHelp': 'You can open and review the statement now, but it cannot be posted or reconciled until the previous statement is complete.',
  'bank.previousMustReconcile': 'The previous bank statement must be reconciled first. You can review this statement, but you cannot post or reconcile it yet.',
  'bank.openStatement': 'Open bank statement',
  'bank.deleteStatement': 'Delete statement',
  'bank.deleteStatementTitle': 'Delete bank statement?',
  'bank.deleteStatementConfirm': '{{fileName}} will be permanently removed. Posted entries and vouchers are not deleted, but they lose their link to the statement. They stay unreconciled until you upload a statement for the period — then they match automatically, or show up as deviations. This cannot be undone.',
  'bank.statementFallback': 'The bank statement',
  'bank.deleteUnavailable': 'Deleting bank statements is not available yet.',
  'bank.deleteSuccess': 'The bank statement was deleted',
  'bank.deleteReopenFirst': 'Reopen the bank statement before deleting it.',
  'bank.deleteNewerFirst': 'Newer bank statements must be deleted first. Delete processed statements from newest to oldest.',
  'bank.deleteError': 'Could not delete the bank statement.',
  'bank.deleteSettledBlocked': 'Reconciled or posted bank statements cannot be deleted.',
  'bank.deleteReverseFirst': 'Reverse the posting before deleting the bank statement.',
  'bank.deleteMatchGroupBlocked': 'The bank statement is part of a posted match group. Reverse the group before deleting the statement.',
  'bank.deleteMatchGroupOffline': 'The bank statement is part of a match group. Try again when you are online.',
  'bank.noArchivedStatements': 'No archived bank statements yet.',
  'bank.archivedHelp': 'Fully reconciled periods end up here once every line has been handled and archived.',
  'bank.uploadFile': 'Upload file',
  'bank.opPrivArchive': 'Operations / Private / Archive',
  'bank.opPrivArchiveHelp': '"Operations" reconciles the company operating account. "Private" is used to tidy a private account and move business-related lines over to operations. "Archive" shows fully reconciled statements.',
  'bank.privateNotLinked': 'A private account is personal and is not linked to a company bank account.',
  'bank.bankAccount': 'Bank account',
  'bank.bankAccountHelp': 'Choose which bank account you are reconciling. Each account has its own number in the chart of accounts (for example 1920 operating account, 1950 tax withholding account) and its own statements.',
  'bank.noAccountsSetUp': 'No bank accounts have been set up',
  'bank.noStatements': 'No bank statements yet.',
  'bank.noStatementsHelp': 'Upload a bank file for the selected account, or check that the right business is selected.',
  'bank.connectBank': 'Connect to your bank',
  'bank.connectBankHelp': 'Connect Plumme directly to your bank via secure Open Banking. Transactions are then fetched automatically and SuperPlumma posts and reconciles continuously — so you do not have to upload statements manually.',
  'bank.connectYourBank': 'Connect to your bank',
  'bank.connect': 'Connect',
  'altinn.sub': 'Send forms on to the authorities — we pre-fill what we can.',
  'altinn.filingVia': 'Filing via Altinn',
  'altinn.open': 'Open Altinn',
  'altinn.openHelp': 'Opens the Altinn portal in a new tab, where you sign in with your ID and complete the filing of the pre-filled forms.',
  'altinn.formsAndStatus': 'Forms and status',
  'altinn.formsAndStatusHelp': 'An overview of the public forms the business must file, with RF reference numbers and status. The status shows whether the form is filed, falls due soon, or has not been filed yet.',
  'altinn.form': 'Form',
  'altinn.formHelp': 'The name of the public form. The RF number in the next column is Skatteetaten\'s official reference for the form.',
  'altinn.statusHelp': '"Filed" has been submitted, "Due soon" is approaching its deadline, and "Not filed" is still outstanding.',
  'setl.sub': 'Company, invoicing, bank and notifications - all in one place.',
  'setl.companyInfo': 'Company details',
  'setl.companyName': 'Company name',
  'setl.invoiceSettings': 'Invoice settings',
  'setl.nextInvoiceNo': 'Next invoice number',
  'setl.defaultPaymentTerms': 'Default payment terms',
  'setl.defaultVatRate': 'Default VAT rate',
  'setl.reminderFee': 'Reminder fee',
  'setl.sendCopyToMe': 'Send a copy to me',
  'setl.sendCopyHelp': 'Get a copy of every invoice by email.',
  'setl.bankAndAccount': 'Bank and account',
  'setl.mainLedgerAccount': 'Main account in the ledger',
  'setl.notifications': 'Notifications',
  'km.pageHelp': 'The mileage log documents business driving and private use of a company car. Business trips give a mileage allowance at the state rate, while private driving is logged without a deduction.',
  'km.newTrip': 'New trip',
  'km.tripType': 'Trip type',
  'km.typeBusiness': 'Business',
  'km.typePrivate': 'Private',
  'km.privateUse': 'Private use',
  'km.privatePurposePh': 'Private use (optional)',
  'km.privateNote': 'Private driving is logged, but gives no deduction and is not posted.',
  'km.ownCar': 'Own car',
  'km.startPlace': 'Starting point',
  'km.stopN': 'Stop {n}',
  'km.stopPh': 'Address along the way',
  'km.destination': 'Destination',
  'km.calculating': 'Calculating...',
  'km.saveChanges': 'Save changes',
  'km.saveEntry': 'Save mileage log entry',
  'km.privateDriving': 'Private driving',
  'km.privateDrivingHelp': 'Private use is documented in the mileage log, but gives no deduction.',
  'km.filterType': 'Type',
  'km.tryOtherSearch': 'Try a different search or reset the filter.',
  'km.distance': 'Distance',
  'km.stops': 'Stops',
  'km.returnYes': 'Yes ({km} km each way)',
  'km.returnNo': 'No',
  'km.status': 'Status',
  'km.statusLogged': 'Logged',
  'km.statusPosted': 'Posted',
  'km.route': 'Route',
  'km.amount': 'Amount',
  'km.deleteTripBody': 'Are you sure you want to delete this trip{route}? This action cannot be undone.',
  'km.speedUnit': 'km/h',
  'km.gps.unavailable': 'GPS is not available in this browser.',
  'km.gps.denied': 'GPS access was denied or could not be started.',
  'km.gps.active': 'GPS active',
  'km.gps.inactive': 'GPS is not active',
  'km.gps.stop': 'Stop trip',
  'km.gps.start': 'Start trip',
  'km.gps.done': 'Trip completed',
  'km.gps.tracking': 'Tracking your position.',
  'km.gps.doneHint': '{km} km registered. Use the distance in the form below.',
  'km.gps.startHint': 'Start the trip to activate GPS tracking.',
  'km.toast.editTrip': 'Edit trip - change it and save again',
  'km.toast.openedNotFound': 'Opened the mileage log. Could not find the exact trip to edit automatically.',
  'km.toast.fillFromTo': 'Fill in at least the from and to addresses first.',
  'km.toast.calcUnavailable': 'Automatic km calculation is not available yet.',
  'km.toast.distanceFailed': 'Could not calculate the distance.',
  'km.toast.kmCalculated': 'Kilometres calculated automatically',
  'km.toast.calcFailed': 'Could not calculate kilometres automatically.',
  'km.toast.fillPrivate': 'Fill in date, from, to and kilometres before saving private driving.',
  'km.toast.fillBusiness': 'Fill in date, from, to, purpose and kilometres before saving.',
  'km.toast.updated': 'The trip has been updated',
  'km.toast.saved': 'The trip has been saved',
  'km.toast.deleted': 'Trip deleted',
  'bank.filter.all': 'All',
  'bank.filter.processing': 'To process',
  'bank.filter.suggestion': 'Suggestion ready',
  'bank.filter.control': 'Needs review',
  'bank.filter.missing': 'Missing voucher',
  'bank.filter.deviation': 'Possible deviation',
  'bank.filter.done': 'Done',
  'bank.typeGroup.sales': 'Sales',
  'bank.typeGroup.purchase': 'Purchases',
  'bank.typeGroup.other': 'Other',
  'bank.typeGroup.tax': 'Tax and duties',
  'bank.typeGroup.loan': 'Loans and debt',
  'bank.type.invoicePayment': 'Invoice payment',
  'bank.type.otherSales': 'Other sales',
  'bank.type.payOpenSupplier': 'Supplier invoice: pay open',
  'bank.type.newSupplier': 'Supplier invoice: register new',
  'bank.type.purchase': 'Regular purchase',
  'bank.type.free': 'Free posting',
  'bank.type.fee': 'Fee',
  'bank.type.rounding': 'Rounding difference',
  'bank.type.owner': 'Private withdrawal / deposit',
  'bank.type.vat': 'VAT payment',
  'bank.type.payroll': 'Withholding tax / employer contributions',
  'bank.type.tax': 'Tax payment',
  'bank.type.loan': 'Loan / debt',
  'bank.agaPart.withholding': 'Withholding tax against 2600',
  'bank.agaPart.employer': 'Employer contributions against 2770',
  'bank.agaPart.both': 'Both combined, split between 2600 and 2770',
  'bank.vat.none': 'No VAT',
  'bank.vat.input': '{{code}} - Input VAT {{rate}} %',
  'bank.accountFallback': 'Account {{code}}',
  'bank.countsAsZero': '{{note}} · counts as 0.00 kr in the reconciliation',
  'bank.csv.date': 'Date',
  'bank.csv.description': 'Description',
  'bank.csv.note': 'Note',
  'bank.csv.amount': 'Amount',
  'bank.csv.balance': 'Balance',
  'bank.posted.amount': 'Posted {{amount}}',
  'bank.posted': 'Posted',
  'bank.posted.vatAmount': 'VAT {{amount}} ({{rate}} %)',
  'bank.posted.vatRate': 'VAT {{rate}} %',
  'bank.err.pickSupplierInvoice': 'Select the supplier invoice the payment relates to.',
  'bank.err.supplierPaymentMustBeOutgoing': 'A supplier invoice payment must be an outgoing bank payment.',
  'bank.err.supplierPaymentUnavailable': 'Paying a supplier invoice from the bank is not available yet.',
  'bank.deviation.intro': 'These entries are posted against the bank account, but Plumme cannot find a safe bank line that explains them.',
  'bank.deviation.none': 'No possible deviations in this period.',
  'bank.detail.date': 'Date',
  'bank.detail.amount': 'Amount',
  'bank.detail.status': 'Status',
  'bank.detail.postId': 'Entry ID',
  'bank.detail.type': 'Type',
  'bank.detail.period': 'Period',
  'bank.detail.noReceipt': 'No voucher is linked to the posting',
  'bank.detail.receiptPreviewable': 'The voucher can be previewed directly here.',
  'bank.detail.noPreview': 'There is no voucher to preview.',
  'bank.toast.postingCorrected': 'The posted entry has been corrected',
  'bank.toast.postingVoided': 'The posting has been voided. Any voucher is back in the inbox.',
  'bank.transition.review': 'Review the transition from the imported accounts before this statement is posted.',
  'bank.transition.fixOpening': '{{message}} Correct the opening balance before you post.',
  'bank.toast.voucherLinkedName': 'Voucher linked: {{name}}',
  'bank.toast.noVoucherSuggestions': 'SuperPlumma has no voucher suggestions to link.',
  'bank.toast.oneVoucherLinked': 'One voucher linked',
  'bank.toast.nVouchersLinked': '{{count}} vouchers linked',
  'bank.toast.linkSuggestedFailed': 'Could not link the suggested vouchers.',
  'bank.toast.linkedToPosted': 'The bank line is linked to the already posted entry',
  'bank.toast.linkToPostedFailed': 'Could not link the bank line to the posted entry.',
  'bank.toast.saveCustomerFirst': 'Save the customer before the line is approved.',
  'bank.toast.saveSupplierFirst': 'Save or select the supplier before the line is approved.',
  'bank.toast.reviewSuggestionFirst': 'Review the suggestion in the bank line before you approve.',
  'bank.toast.invoicePaymentDone': 'The invoice payment is posted and the bank line is done',
  'bank.toast.supplierPaymentDone': 'The supplier invoice is paid and the bank line is done',
  'bank.toast.enterSupplierName': 'Enter the supplier name before the invoice is approved.',
  'bank.toast.enterInvoiceNumber': 'Enter the invoice number before the invoice is approved.',
  'bank.toast.checkCostAccount': 'Check the cost account before the invoice is approved.',
  'bank.toast.supplierInvoiceDone': 'The supplier invoice is posted and the bank line is done',
  'bank.toast.suggestionDone': 'The suggestion is posted and the bank line is done',
  'bank.toast.alreadyDone': 'The bank line is already posted and done',
  'bank.toast.suggestionNotApproved': 'The suggestion could not be approved.',
  'bank.toast.suggestionNeedsReview': 'The suggestion must be reviewed before approval.',
  'bank.approve': 'Approve',
  'bank.toast.pickUnprocessed': 'Select at least one unprocessed bank line.',
  'bank.toast.approveLineFailed': 'Could not approve the bank line.',
  'bank.toast.nLinesApproved': '{{count}} lines approved',
  'bank.toast.lineAdded': 'Bank line added',
  'bank.toast.lineLinkUnavailable': 'Linking a bank line is not available yet.',
  'bank.toast.linkedToExistingPosted': 'The bank line is linked to the existing posted entry',
  'bank.controlPosting.title': 'Posted bank entry',
  'bank.controlPosting.sub': 'Possible deviation: posted on the bank account, but not found in the bank statement.',
  'bank.toast.openedAsDeviation': 'The bank line has been opened as a deviation',
  'bank.toast.investmentMatchReopened': 'The bank match to the investment has been released',
  'bank.toast.balanceCorrectionUnavailable': 'Balance correction is not available yet.',
  'bank.toast.openingMustBeNumber': 'The opening balance must be a number.',
  'bank.toast.openingUpdated': 'Opening balance updated',
  'bank.toast.openingFromImport': 'Opening balance set from the import transition',
  'bank.toast.closingMustBeNumber': 'The closing balance must be a number.',
  'bank.toast.closingUpdated': 'Closing balance updated',
  'bank.toast.roundingMustBeNumber': 'The rounding difference must be a number.',
  'bank.toast.roundingCorrected': 'Rounding difference corrected',
  'bank.mark.posted': 'Posted',
  'bank.mark.alreadyPosted': 'Already posted',
  'bank.mark.approved': 'Approved',
  'bank.mark.needsReview': 'Needs review',
  'bank.mark.deviation': 'Possible deviation',
  'bank.mark.suggestion': 'Suggestion ready',
  'bank.mark.private': 'Private',
  'bank.mark.removed': 'Removed',
  'bank.mark.new': 'Not processed',
  'bank.toast.analysisUnavailable': 'SuperPlumma analysis is not available yet.',
  'bank.toast.foundSuggestions': 'SuperPlumma found {{count}} suggestions to review',
  'bank.toast.noSafeSuggestions': 'SuperPlumma found no safe suggestions',
  'bank.toast.analysisFailed': 'SuperPlumma could not analyse the bank lines.',
  'bank.toast.alreadyArchived': 'The bank statement is already reconciled and archived.',
  'bank.toast.reconciledArchived': 'The bank statement is reconciled and archived.',
  'bank.toast.reopenFailed': 'Could not reopen the reconciliation.',
  'bank.matchMultiple': 'Match several',
  'bank.transition.title': 'Review the transition from the imported accounts',
  'bank.transition.changeAnchor': 'Change "Reconciled through" and the opening balance in Settings if the import anchor was set incorrectly.',
  'bank.previousNotReconciled': 'An earlier period is not reconciled',
  'bank.correctViaPencil': 'Correct via the pencil icon',
  'bank.correctReadBalance': 'Correct the read balance',
  'bank.analysis.alreadyDone': 'The bank statement has already been analysed. A new analysis is blocked to avoid unnecessary token use.',
  'bank.analysis.autoRunning': 'SuperPlumma is analysing the bank statement automatically.',
  'bank.analysis.analyzedShort': 'Analysed by SuperPlumma',
  'bank.analysis.analyzingShort': 'SuperPlumma is analysing',
  'bank.archiveBlocked.chronological': 'Reconcile {{name}} first. Reconciliation must be done chronologically, because the opening balance is taken from the previous statement.',
  'bank.archiveBlocked.deviation': 'The balance discrepancy must be 0.00 kr before the bank statement can be archived.',
  'bank.archiveBlocked.lines': 'All bank lines must be processed before the bank statement can be archived.',
  'bank.reviewAndApprove': 'Review and approve',
  'bank.voucherN': 'Voucher {{n}}',
  'bank.voucherLinked': 'Voucher linked',
  'bank.showVoucher': 'Show voucher',
  'bank.voucherSuggested': 'Voucher suggested',
  'bank.voucherMissingBadge': 'Voucher missing',
  'bank.toast.linkRemoved': 'The link has been removed. The voucher is back in the inbox.',
  'bank.sendVouchersBack': 'Send the vouchers back to the inbox',
  'bank.toast.vouchersSentBack': 'The vouchers have been sent back to the inbox',
  'bank.analysisHint.tap': 'Let SuperPlumma analyse the lines and suggest postings, or tap a voucher and then the bank line to link it.',
  'bank.analysisHint.drag': 'Let SuperPlumma analyse the lines and suggest postings, or drag a voucher straight onto the bank line to link it.',
  'bank.showInbox': 'Show inbox',
  'bank.toast.lineDone': 'The bank line is posted and done',
  'bank.toast.noInboxVouchers': 'There are no vouchers in the inbox to link.',
  'bank.toast.balanceCorrected': 'The balance has been corrected',
  'bank.toast.misreadRemoved': 'The misread line has been removed from the reconciliation',
  'bank.toast.readingCorrected': 'The reading has been corrected',
  'bank.toast.postedFixed': 'The posted entry has been fixed',
  'bank.toast.lineRemoved': 'The bank line has been removed from the reconciliation',
  'bank.vatTerm.jun': 'VAT {{year}} - 10 June',
  'bank.vatTerm.apr': 'VAT {{year}} - 10 April',
  'bank.vatTerm.feb': 'VAT {{year}} - 10 February',
  'bank.vatTerm.aug': 'VAT {{year}} - 31 August',
  'bank.vatTerm.oct': 'VAT {{year}} - 10 October',
  'bank.vatTerm.dec': 'VAT {{year}} - 10 December',
  'bank.agaTerm': 'Payroll tax/employer contributions, term {{n}} {{year}}',
  'bank.ownerAccountFallback': 'Private/owner account',
  'bank.periodHint': 'The bank statement covers {{from}} - {{to}}.',
  'bank.voucher': 'Voucher',
  'bank.ownerType.withdrawal': 'Private withdrawal',
  'bank.ownerType.deposit': 'Private deposit',
  'bank.ownerType.both': 'Private withdrawal / deposit',
  'bank.ownerType.owner': 'Owner / intercompany account',
  'bank.vat86.prefix': 'The supplier amount',
  'bank.vat86.suffix': 'is the basis. Code 86 calculates both output and input VAT at 25% without reducing the bank amount.',
  'bank.postedWithoutVat': 'is posted without VAT.',
  'bank.withVatRate': 'with {{rate}}% VAT.',
  'bank.amountHelp.locked': 'The amount is taken from the bank statement and cannot be changed.',
  'bank.amountHelp.unlocked': 'The posting is not linked to a bank line, so the amount can be corrected here. The change is saved in the audit trail.',
  'bank.amountHelp.mustMatch': 'The amount must match the actual bank transaction.',
  'bank.err.enterAmount': 'Enter the bank amount before you save the line.',
  'bank.err.dateWithinStatement': 'The date must be within the bank statement: {{from}} - {{to}}.',
  'bank.err.pickTwoAccountsFree': 'Select two different accounts before you save the free posting.',
  'bank.err.enterSupplierName': 'Enter the supplier name before you save the supplier invoice.',
  'bank.err.enterInvoiceNumber': 'Enter the invoice number before you post the supplier invoice.',
  'bank.err.invoicePaymentIncoming': 'An invoice payment must be an incoming bank payment.',
  'bank.err.pickInvoice': 'Select an invoice before you save the invoice payment.',
  'bank.err.pickOwnerAccount': 'Select the private/owner account before you approve the entry.',
  'bank.err.pickLoanAccount': 'Select a loan/debt account or use a free posting.',
  'bank.err.loanSplitSum': 'Principal, interest and fees must add up to the bank amount.',
  'bank.err.supplierPaymentOutgoing': 'A supplier invoice payment must be an outgoing bank payment.',
  'bank.err.pickSupplierInvoiceBeforeSave': 'Select a supplier invoice before you save the payment.',
  'bank.err.correctionReason': 'Briefly state why the posting is being corrected.',
  'bank.err.noReceiptReason': 'Enter a short reason why a separate voucher is not needed.',
  'bank.err.linkVoucherOrWaive': 'Link a voucher, or tick the box to indicate that separate documentation does not exist or is not needed.',
  'bank.err.uploadUnavailable': 'Voucher upload is not available yet.',
  'bank.err.analysisFailedAfterUpload': 'The voucher was uploaded, but the analysis failed.',
  'bank.toast.uploadedAndLinked': 'Voucher uploaded and linked to the bank line.',
  'bank.toast.linkOnSaveCorrection': 'The voucher will be linked when you save the correction.',
  'bank.toast.linkOnSaveLine': 'The voucher will be linked when you save the bank line.',
  'bank.err.uploadFailed': 'Could not upload the voucher.',
  'bank.modal.correctPosting': 'Correct posting',
  'bank.modal.editLine': 'Edit bank line',
  'bank.modal.saveCorrection': 'Save correction',
  'bank.modal.approveAndClose': 'Approve and close',
  'bank.modal.fieldsLocked': 'Bank amount, date, type and bank link are locked. Account, VAT and internal description can be corrected with an audit trail.',
  'bank.modal.correctionUnlocked': 'The posting is not linked to a bank line in the bank statement. Date, amount, account, VAT, voucher and internal description can be corrected with an audit trail. If the posting type itself is wrong, the posting must be voided and posted again.',
  'bank.modal.manualLineHelp': 'Use this only when an actual bank transaction is missing from the statement, for example because of an import error or a bank line that must be posted manually before reconciliation.',
  'bank.help.sales': 'Sales use the default sales account and VAT setup. Later this will be linked to invoice/KID when available.',
  'bank.help.ownerSole': '{{label}} is posted between the bank and the selected private account without income, cost or VAT.',
  'bank.help.ownerUnknownEntity': 'The entity type is not set in the settings, so Plumme does not suggest an account here. Choose the counter account yourself, or set the entity type to get a suggestion.',
  'bank.help.ownerIntercompany': 'This is an owner/intercompany account entry, not a private sole proprietorship entry. Choose a documented counter account; loans, dividends and capital contributions must be handled in the correct workflow.',
  'bank.label.privateAccount': 'Private account',
  'bank.label.ownerAccount': 'Owner/intercompany account',
  'bank.help.shareholderTitle': 'Withdrawal from the company.',
  'bank.help.shareholderBody': 'The intercompany account is suggested because it collects the owner relationship in one balance. If this is not a repayment of what the company owes you, it becomes a loan to a shareholder: the Norwegian Limited Liability Companies Act section 8-7 sets requirements for coverage and security, and the Tax Act section 10-11 fourth paragraph taxes it as a dividend for you. Dividends and salary must be posted in their own workflows.',
  'bank.help.invoicePayment': 'Use this when the bank deposit relates to an existing sales invoice. The posting goes against accounts receivable and the selected bank account.',
  'bank.settlement.linked': 'Settlement report linked:',
  'bank.settlement.detail': 'the invoice is paid with {{gross}}, fee {{fee}} and net bank deposit {{payout}}.',
  'bank.help.noInvoiceMatch': 'Change the amount or use Other sales if the deposit does not relate to an invoice.',
  'bank.help.supplierPayment': 'Use this when the bank payment relates to a supplier invoice that is already registered. The payment is posted against accounts payable and the selected bank account.',
  'bank.pickOpenSupplierInvoice': 'Select open supplier invoice',
  'bank.supplierInvoiceRemaining': '{{number}} · {{supplier}} · {{amount}} remaining',
  'bank.overpayment': 'Overpayment {{amount}}.',
  'bank.overpaymentHelp': 'The whole bank amount is registered on the supplier invoice, and the excess remains as a credit with the supplier.',
  'bank.noSupplierInvoiceFits': 'No open supplier invoices match the amount.',
  'bank.noSupplierInvoiceFitsHelp': 'In case of overpayment, the remaining amount must be matched against the invoice and the excess posted separately.',
  'bank.help.taxPayment': 'Use this only for payments to the Tax Administration that are not a specific VAT term or withholding tax/employer contributions.',
  'bank.selectedFeeAccount': 'the selected fee account',
  'bank.selectedRoundingAccount': 'the selected rounding account',
  'bank.help.roundingWarning': 'A rounding difference should normally be less than 1 kr. Larger deviations must be explained by checking the balance and bank lines.',
  'bank.help.free': 'Free posting is used for transfers, debt, intercompany accounts, corrections or other bank events that are not a regular purchase, sale or invoice payment.',
  'bank.help.newSupplierInvoice': 'Use this when the supplier invoice is not registered yet. The bank line is saved with supplier invoice details so it can be linked later.',
  'bank.correction.requiredHint': 'Required. Saved in the audit trail.',
  'bank.correction.reasonPh': 'Briefly describe why the posting is being corrected',
  'bank.noSeparateDoc.bank': 'The bank statement is the documentation – a separate voucher is not needed',
  'bank.noSeparateDoc.other': 'No separate documentation exists or is needed',
  'bank.shortReasonPh': 'Short reason',
  'bank.toast.pickFromInbox': 'Select a voucher from the Inbox, not Documentation.',
  'bank.toast.linkedOnCorrection': 'The voucher is linked when you save the correction.',
  'bank.toast.linkedToLine': 'The voucher is linked to the bank line.',
  'bank.priv.filterAll': 'All',
  'bank.priv.filterOperating': 'Operating',
  'bank.priv.filterNew': 'Not processed',
  'bank.priv.filterIgnore': 'Ignore',
  'bank.priv.statusIgnored': 'Ignored',
  'bank.priv.noSafeMatches': 'No safe voucher matches to link yet',
  'bank.priv.linkedN': 'Linked {{count}} vouchers to private bank lines',
  'bank.priv.pickOneLine': 'Select at least one bank line.',
  'bank.priv.ignoredN': '{{count}} lines ignored',
  'bank.priv.movedN': '{{count}} lines moved to operations',
  'bank.priv.intro': 'Private bank is used as a clean-up tool: mark company-related lines as Operating, and ignore private or irrelevant lines. Lines marked as operating are posted on the operating account.',
  'bank.priv.movedToOperating': 'Moved to operations',
  'bank.priv.noteTap': 'Let SuperPlumma link them automatically, or tap a voucher and then the bank line.',
  'bank.priv.noteDrag': 'Let SuperPlumma link them automatically, or drag a voucher straight onto the bank line.',
  'bank.toast.lineUpdated': 'Bank line updated',
  'bank.err.excelParserMissing': 'The Excel parser has not been loaded.',
  'bank.err.pdfParserMissing': 'The PDF parser has not been loaded.',
  'bank.toast.addBankAccountFirst': 'Add a bank account in settings first',
  'bank.err.archiveUnavailable': 'Archiving a bank statement is not available yet.',
  'bank.toast.privateReviewArchived': 'The private review is completed and archived',
  'bank.err.archiveFailed': 'Could not archive the bank statement',
  'bank.err.reopenUnavailable': 'Reopening a bank statement is not available yet.',
  'bank.toast.statementReopened': 'The bank statement has been reopened',
  'bank.err.reopenStatementFailed': 'Could not reopen the bank statement',
  'bank.account.private': 'Private account',
  'bank.account.operating': 'Operating account',
  'bank.group.operating': 'Operating accounts',
  'bank.group.private': 'Private accounts',
  'bank.group.doneReviews': 'Completed private statement reviews',
  'bank.group.doneReconciled': 'Completed reconciled bank statements',
  'bank.unknownPeriod': 'Unknown period',
  'bank.handledOf': '{{handled}} of {{lines}} handled',
  'bank.page.privateTitle': 'Private bank',
  'bank.page.title': 'Bank reconciliation',
  'bank.page.privateSubtitle': 'Clean up the private account - mark company-related lines as operating and ignore the rest.',
  'bank.page.subtitle': 'Upload XLSX, CSV, PDF or a screenshot from the bank, mark company lines as operating, and archive completed statements.',
  'bank.tab.operating': 'Operating',
  'bank.tab.private': 'Private',
  'bank.tab.archive': 'Archive',
  'bank.page.privateUploadHelp': 'Upload the private statement here only when you want to find company-related expenses. It is saved on the selected company, but without a bank account from Settings.',
  'bank.noAccountRegistered': 'No bank account registered',
  'bank.stmt.reviewed': 'Reviewed',
  'bank.stmt.toReview': 'To review',
  'bank.stmt.toReconcile': 'To reconcile',
  'bank.dropzone.uploadMore': 'Upload more bank statements',
  'bank.dropzone.none': 'No bank statements yet',
  'bank.dropzone.help': 'Drag in a CSV, PDF, XLSX or image file from the bank, click to select, or paste a screenshot with Ctrl+V. We match the lines against your vouchers automatically.',
  'bank.connectHelp2': 'Fetch transactions automatically and let SuperPlumma post and reconcile the accounts continuously - no manual upload and posting.',
  'bank.toast.openBankingInfo': 'Secure connection to the bank via Open Banking',
  'bank.guided.step1.title': 'Check the statement',
  'bank.guided.step1.sub': 'Check the period and balance',
  'bank.guided.step2.title': 'Approve suggestions',
  'bank.guided.step2.sub': 'Review what Plumme has found',
  'bank.guided.step3.title': 'Process the rest',
  'bank.guided.step3.sub': 'Choose what the payments are for',
  'bank.guided.step4.title': 'Link vouchers',
  'bank.guided.step4.sub': 'Document the purchases',
  'bank.guided.step5.title': 'Finish',
  'bank.guided.step5.sub': 'Check and archive',
  'bank.guided.stepOf': 'Step {{step}} of {{total}}',
  'bank.guided.action.matched': 'Matched against already posted',
  'bank.guided.action.fee': 'Bank fee',
  'bank.guided.action.invoice': 'Invoice payment',
  'bank.guided.action.purchase': 'Known purchase',
  'bank.guided.action.sale': 'Register sale',
  'bank.guided.suggestionFromSuper': 'Suggestion from SuperPlumma',
  'bank.guided.receivables': 'Accounts receivable',
  'bank.guided.suggestedCostAccount': 'Suggested cost account',
  'bank.guided.reason.sameAmount': 'Same amount and payment reference',
  'bank.guided.reason.textBased': 'Based on text, amount and previous postings',
  'bank.guided.suggestsAction': 'Plumme suggests: {{action}}',
  'bank.guided.vatLine': '{{account}} · {{vat}} VAT · Amount {{amount}}',
  'bank.guided.voucherSuffix': ' · voucher: {{name}}',
  'bank.guided.out': 'OUT',
  'bank.guided.in': 'IN',
  'bank.guided.moneyOut': 'MONEY OUT',
  'bank.guided.moneyIn': 'MONEY IN',
  'bank.guided.unprocessedLine': '{{direction}} · Not processed',
  'bank.guided.bankPeriod': 'Bank period',
  'bank.guided.handledLeft': '{{handled}}/{{total}} processed · {{left}} left',
  'bank.guided.reopenNote': 'If you reopen the reconciliation, the period is unlocked for review. Posted lines must be corrected or voided with an audit trail before they can be processed again.',
  'bank.guided.toast.enterClosing': 'Enter the closing balance from the bank statement.',
  'bank.guided.err.checkIndividually': 'One or more suggestions must be reviewed individually.',
  'bank.guided.toast.suggestionsDone': '{{count}} suggestions are posted and done',
  'bank.guided.err.approveSuggestions': 'Could not approve the suggestions.',
  'bank.guided.toast.roundingPosted': 'The rounding difference of {{amount}} has been posted',
  'bank.guided.err.roundingFailed': 'Could not post the rounding difference.',
  'bank.guided.toast.markedNoVoucher': 'The purchase is marked as having no voucher',
  'bank.guided.err.saveChoice': 'Could not save the choice.',
  'bank.guided.err.voucherNotFound': 'Could not find the voucher in the inbox.',
  'bank.guided.err.linkFailed': 'Could not link the voucher.',
  'bank.guided.toast.noSafeHits': 'Found no safe voucher matches to link.',
  'bank.guided.h.check': 'Do the period and balance match?',
  'bank.guided.h.rest': 'What are the remaining payments for?',
  'bank.guided.p.check': 'Check that this is the right bank statement, and enter the balance shown at the end of the period.',
  'bank.guided.p.rest': 'Choose what each payment is for. You do not need to know account numbers — Plumme helps you with the posting.',
  'bank.guided.openingHint': 'Normally taken from the previous completed reconciliation.',
  'bank.guided.closingHint': 'Find the amount on the statement from the bank.',
  'bank.guided.closingMatches': 'The bank closing balance equals what Plumme has calculated.',
  'bank.guided.posting': 'Posting…',
  'bank.guided.postRounding': 'Post the rounding difference',
  'bank.guided.smallRounding': 'Small rounding deviation of {{amount}}',
  'bank.guided.balanceDeviates': 'The balance deviates by {{amount}}.',
  'bank.guided.balanceDeviatesHelp': 'Process the payments in the next steps and come back if the deviation remains.',
  'bank.guided.canReturn': 'You can always return to this step later.',
  'bank.guided.correctToContinue': 'Correct the balances with the pencil icon to continue.',
  'bank.guided.checkedContinue': 'The statement is checked – continue',
  'bank.guided.superIntro': 'Some lines are matched against entries that are already posted, and for others SuperPlumma has suggested a posting. Review them and press approve — nothing is posted until you approve.',
  'bank.guided.count.matched': 'matched against already posted',
  'bank.guided.count.invoice': 'invoice payments',
  'bank.guided.count.purchase': 'known purchases',
  'bank.guided.count.fee': 'bank fees',
  'bank.guided.count.receipt': 'vouchers found automatically',
  'bank.guided.fixReading': 'Correct the reading from PDF/CSV',
  'bank.guided.suggestionsPending': '{{count}} suggestions are not approved yet. You can approve them now or come back.',
  'bank.guided.allSuggestionsDone': 'All suggestions have been processed.',
  'bank.guided.tabHandling': 'To process · {{count}}',
  'bank.guided.tabDeviation': 'Causes deviation · {{count}}',
  'bank.guided.postsCauseDeviation': '{{count}} posted entries cause a deviation',
  'bank.guided.linkHelp': 'Link a receipt or invoice to the purchase. If the documentation does not exist, choose "Without voucher" so the choice is saved and can be reviewed later.',
  'bank.guided.purchasesMissing': '{{count}} purchases are missing vouchers.',
  'bank.guided.noneMissing': 'No vouchers are missing.',
  'bank.guided.ctl.allHandled': 'All payments are processed',
  'bank.guided.ctl.remaining': '{{count}} remaining',
  'bank.guided.ctl.vouchersLinked': 'Required vouchers are linked',
  'bank.guided.ctl.missingVouchers': '{{count}} missing vouchers',
  'bank.guided.ctl.statementBalances': 'The bank statement balances match',
  'bank.guided.ctl.deviation': 'Deviation {{amount}}',
  'bank.guided.ctl.ledgerBalance': 'The posted bank balance matches',
  'bank.guided.ctl.clear': 'Ready',
  'bank.guided.finishNote': 'When you finish, Plumme checks the balances, locks the period and moves the statement to the archive.',
  'bank.guided.allChecked': 'Everything is checked and ready.',
  'bank.guided.resolveToFinish': 'Resolve the items above to unlock finishing.',
  'bank.guided.toast.noPending': 'No suggestions are waiting for approval.',
  'bank.guided.superLinks': 'SuperPlumma links',
  'bank.guided.approveSuggestions': 'Approve the suggestions',
  'bank.guided.note.tapPurchase': 'Tap a voucher, then the purchase you want to link it to.',
  'bank.guided.note.tapSuggestion': 'Tap a voucher, then the suggestion. A possible match is highlighted in the list.',
  'bank.guided.note.dragPurchase': 'Drag a voucher onto the purchase you want to link it to.',
  'bank.guided.note.dragSuggestion': 'Drag a voucher onto a suggestion. A possible match is highlighted in the list.',
  'bank.guided.err.checkImportFirst': 'Review the import transition first.',
  'bank.guided.toast.postingVoided': 'The posting has been voided',
  'bank.guided.archiving': 'Archiving…',
  'bank.guided.archiveNote': 'The review is locked and moved to the archive. The bank lines were already posted when they were approved.',
  'bank.archive.lockedNote': 'The reconciliation is locked. Expand a line to see the voucher and posting. Account, VAT and internal description can be corrected without changing the bank amount.',
  'bank.archive.searchPh': 'Search postings',
  'bank.archive.searchHelp': 'Search by date, description, amount, account or voucher.',
  'bank.archive.countOf': '{{shown}} of {{total}} postings',
  'bank.archive.handled': 'Processed',
  'bank.archive.code': 'Code {{code}}',
  'bank.archive.auditTrail': 'Audit trail',
  'bank.archive.correctionsOne': '{{count}} correction',
  'bank.archive.correctionsMany': '{{count}} corrections',
  'bank.archive.noCorrections': 'No corrections',
  'bank.archive.internalDescription': 'Internal description',
  'bank.archive.noVoucher': 'No voucher linked',
  'bank.archive.noMatch': 'No postings match the search or filters.',
  'bank.archive.err.correctFailed': 'Could not correct the posting.',
  'bank.importFix.err.openFirst': 'Open the link or the posting before the reading is corrected.',
  'bank.importFix.err.reasonLine': 'Briefly state why the bank line is being corrected.',
  'bank.importFix.err.amountNumber': 'The amount must be a number.',
  'bank.importFix.removeFromRecon': 'Ignore line',
  'bank.importFix.warnTitle': 'Use only if the PDF/CSV was read incorrectly.',
  'bank.importFix.warnBody': 'This does not change the bank or posted vouchers. The original values are kept in the history.',
  'bank.importFix.blocked': 'The line is already linked or posted. Open the link/posting before the reading itself is corrected.',
  'bank.importFix.originalRead': 'Originally read',
  'bank.importFix.effect': 'Effect on reconciliation',
  'bank.importFix.deviationNow': 'Deviation now:',
  'bank.importFix.afterCorrection': 'After correction:',
  'bank.importFix.stillDeviates': 'If the deviation remains, check whether the opening/closing balance was also read incorrectly.',
  'bank.importFix.fixLine': 'Correct the line',
  'bank.importFix.removeMisread': 'Ignore line', 'bank.ignoreLine': 'Ignore line', 'bank.ignoreLineHelp': 'Use this only when the line was misread and does not exist in the bank statement. The line remains in the history.', 'bank.ignoreLineConfirm': 'Ignore the line', 'bank.ignoreLineReason': 'Why is the line ignored?', 'bank.ignoreLineReasonHint': 'Required for the audit trail.', 'bank.ignoreLineReasonPlaceholder': 'E.g. the line does not exist in the bank statement',
  'bank.importFix.removeNote': 'The line stays in the history, but counts as 0.00 kr and is treated as done in the reconciliation. Use only when the line does not exist in the bank statement.',
  'bank.importFix.whyReading': 'Why is the reading being corrected?',
  'bank.importFix.whyReadingPh': 'E.g. OCR read the wrong amount / the line does not exist in the bank statement',
  'bank.importFix.err.balancesNumber': 'Opening and closing balance must be numbers.',
  'bank.importFix.err.reasonBalance': 'Briefly state why the balance is being corrected.',
  'bank.importFix.saveBalance': 'Save balance',
  'bank.importFix.balanceWarnTitle': 'Change only if the balance from the statement/import is wrong.',
  'bank.importFix.balanceWarnBody': 'The opening balance is normally taken from the previous reconciled closing balance. The original read balance is kept.',
  'bank.importFix.resultPrefix': 'With today\'s processed bank lines the balance discrepancy becomes',
  'bank.importFix.whyBalance': 'Why is the balance being corrected?',
  'bank.importFix.whyBalancePh': 'E.g. the closing balance was read from the wrong row in the PDF',
  'bank.loan.intro': 'Use this for loan drawdowns, repayments or payments that can be split into principal, interest and fees. The selected account is taken from the company\'s active chart of accounts, and the entry is posted without VAT.',
  'bank.loan.account': 'Loan/debt account',
  'bank.loan.noAccount': 'Found no regular loan/debt account in the active chart of accounts. Create the correct account or use a free posting.',
  'bank.loan.principal': 'Principal / loan amount',
  'bank.loan.splitMismatch': 'The split must match the bank amount. Remaining: {{amount}} kr.',
  'bank.loan.docLinked': 'Documentation is linked.',
  'bank.loan.docRemember': 'Remember the documentation.',
  'bank.loan.docHelp': 'Upload the loan agreement, repayment plan or other supporting documents. The split must be documentable.',
  'bank.loan.complex': 'Does the line involve a related party, an unusual account or a more complicated loan arrangement?',
  'bank.loan.useFree': 'Use free posting',
  'bank.group.err.sameDirection': 'All bank lines in an allocation group must have the same direction.',
  'bank.group.err.pickBoth': 'Select both bank lines in the transfer.',
  'bank.group.toast.transferApproved': 'The transfer has been approved and posted together.',
  'bank.group.toast.allocationApproved': 'The allocation has been approved and posted together.',
  'bank.group.err.approveFailed': 'Could not approve the matching group.',
  'bank.group.title': 'Match several bank events',
  'bank.group.approve': 'Approve and post group',
  'bank.group.oneOperation': 'One controlled operation',
  'bank.group.oneOperationHelp': 'The group reserves all selected bank lines. Posting and linking happen together in the backend when you approve.',
  'bank.group.matchType': 'Matching type',
  'bank.group.typeAllocation': 'Allocate payment against open items',
  'bank.group.typeTransfer': 'Internal transfer between own accounts',
  'bank.group.sourceLine': 'Line from one account',
  'bank.group.counterLine': 'Counter entry on own account',
  'bank.group.pickOpposite': 'Select the opposite bank line',
  'bank.group.transferRules': 'Only the same date and amount, opposite sign and a different configured bank account are offered. Different dates require a transit account.',
  'bank.group.noOpenItems': 'No open {{kind}} can be allocated.',
  'bank.group.customerInvoices': 'customer invoices',
  'bank.group.supplierInvoices': 'supplier invoices',
  'bank.group.itemRest': '{{number}} · {{party}} · remaining {{amount}}',
  'bank.group.removeRow': 'Remove row',
  'bank.corr.err.reasonVoid': 'Briefly state why the posting is being voided.',
  'bank.corr.err.notFieldCorrectable': 'This entry type cannot be corrected field by field from the bank reconciliation. Void the posting and post it correctly again, or open the voucher in the voucher journal.',
  'bank.corr.err.supplierPaymentVoid': 'Supplier invoice payments are voided from the supplier voucher.',
  'bank.corr.err.noSupportedAction': 'Could not find a supported action for this posted entry.',
  'bank.receipt.toast.trashed': 'The voucher has been moved to the trash.',
  'bank.receipt.err.deleteFailed': 'Could not delete the voucher.',
  'bank.receipt.deleting': 'Deleting…',
  'bank.receipt.delete': 'Delete voucher',
  'bank.mode.toFull': 'Switch to full overview',
  'bank.mode.toGuided': 'Switch to step by step',
  'bank.import.toast.privateSaved': 'Private statement saved - ready for review',
  'bank.import.toast.saved': 'Bank statement saved - ready for reconciliation',
  'bank.inbox.view.statement': 'This statement',
  'bank.inbox.view.unlinked': 'Only unlinked',
  'bank.inbox.view.all': 'All vouchers',
  'bank.inbox.showInList': 'Show in the inbox',
  'bank.inbox.viewing': 'Showing: {{view}} · {{hidden}} hidden',
  'bank.inbox.waiting': '{{count}} vouchers are waiting for work',
  'bank.inbox.hide': 'Hide inbox',
  'bank.inbox.companyAddress': 'the company voucher inbox',
  'bank.inbox.defaultNote': 'Drag a voucher onto a bank line, or let SuperPlumma suggest matches.',
  'bank.inbox.uploadVoucher': 'Upload voucher',
  'bank.inbox.orDrag': 'Or drag · drop onto a line that is missing a voucher',
  'bank.inbox.dropHint': 'Drop files here to upload new vouchers.',
  'bank.inbox.noMatch': 'No vouchers match the search.',
  'bank.inbox.noneInSelection': 'No vouchers in this selection · {{hidden}} hidden by the filter',
  'bank.inbox.allDone': 'All vouchers have been processed',
  'bank.inbox.empty': 'The inbox is empty',
  'bank.inbox.tip.showAll': 'Click to show all bank lines again',
  'bank.inbox.tip.showLine': 'Click to show the bank line this voucher is linked to',
  'bank.inbox.tip.linkedElsewhere': 'Linked outside this bank statement',
  'bank.inbox.linkedHere': 'Linked · {{label}}',
  'bank.inbox.linkedIn': 'Linked in {{label}}',
  'bank.inbox.previewName': 'Preview {{name}}',
  'bank.inbox.voucherLower': 'voucher',
  'bank.inbox.filteredOne': 'Filtered on one voucher',
  'bank.inbox.filteredN': 'Filtered on {{count}} vouchers',
  'bank.inbox.filterShowsLinked': 'Shows only the bank lines the vouchers are linked to',
  'bank.inbox.showAllLines': 'Show all lines',
  'bank.inbox.nBankLines': '{{count}} bank lines',
  'bank.inbox.bankLineLower': 'bank line',
  'bank.inbox.anotherStatement': 'another bank statement',
  'bank.inbox.toast.linkedElsewhere': 'The voucher is linked to a bank line in {{label}}.',
  'bank.resolve.annulText': 'The entry is a duplicate. Reverse it so it does not count. Any voucher is automatically put back in the inbox.',
  'bank.resolve.correctText': 'The posting should exist, but the account, VAT or internal description is wrong. Bank amount and date remain locked.',
  'bank.resolve.err.voidFailed': 'Could not void the posted entry.',
  'bank.resolve.voiding': 'Voiding…',
  'bank.resolve.confirmVoid': 'Confirm voiding',
  'bank.resolve.voidReason': 'Reason for voiding',
  'bank.resolve.voidReasonHint': 'Required. The reason is saved in the audit trail.',
  'bank.resolve.voidReasonPh': 'Briefly describe why the posting should be voided',
  'bank.resolve.row.postedEntry': 'Posted entry',
  'bank.resolve.row.account': 'Account',
  'bank.resolve.row.vat': 'VAT',
  'bank.resolve.row.amount': 'Amount',
  'bank.resolve.row.lineDate': 'Bank line date',
  'bank.resolve.row.bankLine': 'Bank line',
  'bank.resolve.row.voucher': 'Voucher',
  'bank.resolve.row.notLinked': 'Not linked',
  'bank.resolve.reopenAsDeviation': 'Open as deviation',
  'bank.resolve.releaseInvestmentMatch': 'Release bank match',
  'bank.resolve.reverse': 'Reverse',
  'bank.resolve.alreadyPosted': 'This bank line is already posted or matched. It therefore cannot be processed as a new line.',
  'bank.resolve.useCorrection': 'Use correction for account, VAT or internal description. Bank amount, date and link remain locked.',
  'bank.resolve.reverseInfo': 'Reversal voids the purchase with an audit trail and opens the bank line for a new review.',
  'bank.resolve.existingInfo': 'This is linked to an existing voucher or entry. Correct the voucher itself if the basis is wrong.',
  'bank.resolve.verifiableInfo': 'This link can be verified from the entry details.',
  'bank.resolve.approving': 'Approving…',
  'bank.resolve.approveN': 'Approve {{count}} suggestions',
  'bank.resolve.confirmIntro': 'Review the summary. Suggestions matched against an existing entry do not create new postings.',
  'bank.resolve.voucherReturns': 'The voucher "{{name}}" is automatically put back in the inbox when the entry is voided.',
  'bank.err.uploadVoucherFailed': 'Could not upload the voucher.',
  'bank.drop.attachAsDoc': 'Attached as documentation',
  'bank.drop.uploadAnalyzeLink': 'Uploaded, analysed and linked',
  'bank.receipt.confirmDelete': 'Delete the voucher from the inbox? It is moved to the trash and can be restored.',
  'bank.percentDone': '{{pct}}% complete',
  // My page (minside)
  'mypage.role.owner': 'Owner',
  'mypage.role.admin': 'Administrator',
  'mypage.role.accountant': 'Accountant',
  'mypage.role.viewer': 'Viewer',
  'mypage.shortcut.oversikt.title': 'Overview',
  'mypage.shortcut.oversikt.text': 'Health score and financial overview for the household',
  'mypage.shortcut.forbruk.title': 'Spending',
  'mypage.shortcut.forbruk.text': 'Where the money goes, split by category',
  'mypage.shortcut.familie.title': 'Family',
  'mypage.shortcut.familie.text': 'Shared budget and split within the household',
  'mypage.shortcut.fremtid.title': 'Future',
  'mypage.shortcut.fremtid.text': 'Savings, loans, pension and future plans',
  'mypage.shortcut.skatt.title': 'Tax',
  'mypage.shortcut.skatt.text': 'Personal tax return, deductions and estimate',
  'mypage.fallback.business': 'Business',
  'mypage.fallback.signedInUser': 'Signed-in user',
  'mypage.fallback.employerLoadError': 'Could not load employers.',
  'mypage.verify.body': 'Some features, including client invitations and the employee portal, require {{email}} to be verified. Resend the link if you cannot find it, open the link in the email and then confirm here.',
  'mypage.verify.resend': 'Resend verification',
  'mypage.verify.sending': 'Sending...',
  'mypage.verify.confirmed': 'I have verified',
  'mypage.verify.checking': 'Checking...',
  'mypage.err.profileNotConnected': 'Profile saving is not connected to the backend.',
  'mypage.toast.profileUpdated': 'Profile updated',
  'mypage.err.profileUpdateFailed': 'Could not update the profile.',
  'mypage.err.verifyNotConnected': 'Email verification is not connected to the backend.',
  'mypage.toast.alreadyVerified': 'The email address is already verified.',
  'mypage.toast.verifyResent': 'Verification link has been resent.',
  'mypage.err.verifySendFailed': 'Could not send the verification link.',
  'mypage.err.verifyStatusFailed': 'Could not check the email status.',
  'mypage.toast.emailVerified': 'The email address is verified.',
  'mypage.toast.stillUnverified': 'The address is still not verified. Check your inbox and try again.',
  'mypage.err.personalNotConnected': 'Personal finance is not connected to the backend in this build.',
  'mypage.toast.personalCreated': 'Personal finance created',
  'mypage.err.personalCreateFailed': 'Could not create personal finance.',
  'mypage.toast.openPersonalForFamily': 'Open Personal finance to change Family.',
  'mypage.toast.familyEnabled': 'Family is enabled.',
  'mypage.toast.familyDisabled': 'Family is disabled.',
  'mypage.err.familySaveFailed': 'Could not save the Family setting.',
  'mypage.titleHelp': 'My page is your personal account in Plumme, separate from the accounts themselves. Here you see your profile, the businesses you have access to, the employers you work for, and the entrance to your personal finances.',
  'mypage.field.memberSince': 'Member since',
  'mypage.toast.onboardingNotLoaded': 'Onboarding has not loaded yet.',
  'mypage.orgNumber': 'Org. {{orgnr}}',
  'mypage.biz.loadingTitle': 'Loading businesses',
  'mypage.biz.loadingText': 'Connecting to the Plumme backend.',
  'mypage.biz.emptyTitle': 'No businesses of your own',
  'mypage.biz.emptyText': 'You can create a business here later, even if you only use Plumme as an accountant or private user.',
  'mypage.clients.title': 'Client assignments',
  'mypage.clients.help': 'Businesses where you are invited as accountant, administrator or viewer. Client data is kept separate from your own businesses and Personal finance.',
  'mypage.clients.setup': 'Accountant setup',
  'mypage.clients.access': 'Client access',
  'mypage.clients.empty': 'You have no active client assignments. Invitations are shown globally after sign-in.',
  'mypage.pf.creating': 'Creating...',
  'mypage.pf.create': 'Create personal finance',
  'mypage.pf.intro': 'Your personal adviser for household finances, kept separate from the businesses\' accounts. Choose an overview to get started.',
  'mypage.pf.family': 'Family',
  'mypage.pf.familyText': 'Show the Family page in Personal finance.',
  'mypage.pf.emptyIntro': 'Create a personal finance client to gather your private overview, import, household, tax and reports without mixing them with your accounting clients.',
  'mypage.emp.fallbackRole': 'Employee',
  'mypage.emp.loadingTitle': 'Loading employers',
  'mypage.emp.emptyTitle': 'No employers',
  'mypage.emp.loadingText': 'Connecting to the employee portal.',
  'mypage.emp.emptyText': 'No employee portal access is registered for this user.',
  'mypage.err.passwordResetNotConnected': 'Password reset is not connected to the backend.',
  'mypage.toast.passwordLinkSent': 'A link to change your password has been sent by email',
  'mypage.err.passwordLinkFailed': 'Could not send the password link.',
  'mypage.saving': 'Saving...',
  'mypage.hh.loadError': 'Could not load the household link.',
  'mypage.hh.updateError': 'Could not update the household.',
  'mypage.hh.inviteEmailFailed': 'The invitation was created, but the email could not be sent. You can try again.',
  'mypage.hh.inviteSent': 'The invitation was created and sent.',
  'mypage.hh.left': 'The household link has ended.',
  'mypage.hh.hiddenPending': 'The invitation was withdrawn and removed from the list.',
  'mypage.hh.hidden': 'The invitation was removed from the list.',
  'mypage.hh.loading': 'Loading household status …',
  'mypage.hh.partnerFallback': 'Connected partner',
  'mypage.hh.twoAccounts': 'Two separate accounts · shared Family page',
  'mypage.hh.leaveConfirm': 'Disconnect the household? Both keep their own data, while the shared Family profile ends.',
  'mypage.hh.leaving': 'Disconnecting …',
  'mypage.hh.leave': 'Disconnect household',
  'mypage.hh.inviteIntro': 'Invite a partner by email. The recipient can sign in or create a new Plumme account, and gets help creating Personal finance before the link is approved.',
  'mypage.hh.inviting': 'Creating …',
  'mypage.hh.invite': 'Invite partner',
  'mypage.hh.userFallback': 'Plumme user',
  'mypage.hh.joined': 'The household has been linked.',
  'mypage.hh.sentInvites': 'Sent invitations',
  'mypage.hh.resendFailedToast': 'The invitation is active, but the email could not be sent.',
  'mypage.hh.resentToast': 'The invitation has been resent.',
  'mypage.hh.resend': 'Resend',
  'mypage.hh.remind': 'Remind',
  'mypage.hh.withdrawn': 'The invitation has been withdrawn.',
  'mypage.hh.removeFromList': 'Remove from list',
  'mypage.hh.status.pending': 'Awaiting reply · {{delivery}}',
  'mypage.hh.status.expired': 'Expired',
  'mypage.hh.status.declined': 'Declined',
  'mypage.hh.status.canceled': 'Withdrawn',
  'mypage.hh.status.accepted': 'Accepted',
  'mypage.hh.delivery.delivered': 'email delivered',
  'mypage.hh.delivery.opened': 'email opened',
  'mypage.hh.delivery.clicked': 'link opened',
  'mypage.hh.delivery.failed': 'email failed',
  'mypage.hh.delivery.bounced': 'email bounced',
  'mypage.hh.delivery.complained': 'marked as spam',
  'mypage.hh.delivery.delivery_delayed': 'email delayed',
  'mypage.hh.delivery.sent': 'email sent',
  // Activity log (aktivitetslogg)
  'audit.domain.settings': 'Settings',
  'audit.domain.invoices': 'Invoices',
  'audit.domain.sales': 'Sales',
  'audit.domain.expenses': 'Purchases',
  'audit.domain.customers': 'Customers',
  'audit.domain.products': 'Products',
  'audit.domain.suppliers': 'Suppliers',
  'audit.domain.inbox': 'Inbox',
  'audit.domain.bank': 'Bank',
  'audit.domain.mileage': 'Mileage log',
  'audit.domain.payroll': 'Payroll',
  'audit.domain.business': 'Business',
  'audit.domain.access': 'Access',
  'audit.summary.rows': '{{count}} rows',
  'audit.summary.fields': '{{count}} fields',
  'audit.event.updated': 'Updated {{domains}}',
  'audit.event.updatedBusinessData': 'Updated the business data',
  'audit.event.businessCreated': 'Created the business',
  'audit.event.inviteCreated': 'Invited {{email}} as {{role}}',
  'audit.event.inviteAccepted': '{{user}} accepted the invitation',
  'audit.event.deletionRequestedFor': 'Requested deletion of the business on {{date}}',
  'audit.event.deletionRequested': 'Requested deletion of the business',
  'audit.event.deletionCanceled': 'Cancelled deletion of the business',
  'audit.fallback.newUser': 'new user',
  'audit.fallback.userLower': 'user',
  'audit.fallback.user': 'User',
  'audit.fallback.unknownUser': 'Unknown user',
  'audit.err.loadFailed': 'Could not load the activity log.',
  'audit.meta.time': 'Time',
  'audit.meta.user': 'User',
  'audit.meta.role': 'Role',
  'audit.meta.action': 'Action',
  'audit.meta.source': 'Source',
  'audit.meta.invite': 'Invitation',
  'audit.meta.targetUser': 'Target user',
  'audit.detail.before': 'Before:',
  'audit.detail.after': 'After:',
  'audit.titleHelp': 'The activity log is an audit trail: it shows every important action taken in the accounts - who did what, when, and in which area. Useful for traceability and control when several people collaborate.',
  'audit.search': 'Search the activity log for {{year}}',
  'audit.scope.all': 'All',
  'audit.scope.others': 'Others',
  'audit.scope.mine': 'Me',
  'audit.scope.access': 'Access',
  'audit.col.event': 'Event',
  'audit.empty.loadingTitle': 'Loading the activity log',
  'audit.empty.loadingText': 'Connecting to the Plumme backend.',
  'audit.empty.noMatchTitle': 'No matches',
  'audit.empty.noMatchText': 'No activity matches the filter. Try resetting it.',
});
